import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "common-cancel-confirm-modal",
  templateUrl: "./cancel-confirm.modal.component.html",
  styleUrls: ["./cancel-confirm.modal.component.scss"],
})
export class CancelConfirmModalComponent {
  confirmationTitle: string = "Accept Title";
  confirmationMessage: string = "Are you sure?";
  confirmationSubText: string;
  cancelButtonTitle: string = "Cancel";
  acceptButtonTitle: string = "Accept";

  inputVerifyText: string;
  inputValueToVerify: string;
  disableConfirm: boolean;

  dropdownItems: { label: string; value: any }[];
  selectedDropdownItem: any;

  inputExtraLabel: string;
  inputExtraValue: any;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.verifyInput("");
    if (this.dropdownItems && this.dropdownItems.length > 0) {
      this.selectedDropdownItem = this.dropdownItems[0].value;
    }
    if (this.inputExtraValue === undefined && this.inputExtraLabel) {
      this.inputExtraValue = "";
    }
  }

  verifyInput(input) {
    if (!this.inputValueToVerify) {
      this.disableConfirm = false;
      return;
    }
    this.disableConfirm = this.inputValueToVerify != input;
  }

  confirm() {
    // If dropdown or extra input is present, pass both values; else pass true
    if ((this.dropdownItems && this.dropdownItems.length > 0) || this.inputExtraLabel) {
      this.activeModal.close({
        selectedDropdownItem: this.selectedDropdownItem,
        inputExtraValue: this.inputExtraValue,
      });
    } else {
      this.activeModal.close(true);
    }
  }
}
